
import React, { useState, useEffect } from "react";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import FormSelect from "Common/Custom/FormSelect";
import FormSubmitButton from "Common/Custom/FormSubmitButton";
import { Link } from "react-router-dom";

const RoomCheckOutForm = ({
  values = {},
  errors = {},
  CheckInRoomsOpction = [],
  fields = [],
  handleChange = () => { },
  handleSearch = () => { },
  loading = false
}) => {
  const [CheckInRoomsOpctions, setRoomsOpction] = useState([]);

  useEffect(() => {
    const options = CheckInRoomsOpction?.map((opt) => ({
      value: opt.booked_id,
      label: opt.full_guest_name
    }));
    setRoomsOpction(options);
  }, [CheckInRoomsOpction])

  return (
    <PageBody headerchildren={
      <HeadingOne>CheckOut</HeadingOne>
    }>
      {fields.map((field) => {
        return (
          <FormSelect
            key={field.name}
            field={field}
            value={values[field.name]}
            handleChange={handleChange}
            options={CheckInRoomsOpctions}
            error={errors[field.name]}
          />
        )

      })}
      <FormSubmitButton
        label="Search"
        type="button"
        loading={loading}
        colSize="col-md-2 mt-md-5"
        align="start"
        onClick={handleSearch}
      />

      <div className="col-lg-3 ms-auto mt-auto d-flex">
        <Link to="/check-out/checkout-management" className="ms-auto btn btn-primary">
          Checkout Management
        </Link>
      </div>

    </PageBody>
  );
};

export default RoomCheckOutForm;
